declare namespace $ {

	type $mol_paragraph__title_shm_hitalama_agent_session_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['chat_backend_label'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_select__hint_shm_hitalama_agent_session_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_select['hint'] >
	>
	type $mol_select__value_shm_hitalama_agent_session_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['agent_config'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_hitalama_agent_session_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['agent_config_dictionary'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_view__attr_shm_hitalama_agent_session_5 = $mol_type_enforce<
		({ 
			'title': ReturnType< $shm_hitalama_agent_session['chat_model_hint'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_shm_hitalama_agent_session_7 = $mol_type_enforce<
		({ 
			'title': ReturnType< $shm_hitalama_agent_session['context_hint'] >,
			'usage': ReturnType< $shm_hitalama_agent_session['context_usage_level'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_8 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_switch__value_shm_hitalama_agent_session_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['view_mode'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_shm_hitalama_agent_session_10 = $mol_type_enforce<
		({ 
			'dialog': string,
			'raw': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_labeler__title_shm_hitalama_agent_session_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_agent_session_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['View_mode'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_select__value_shm_hitalama_agent_session_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['provider_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_shm_hitalama_agent_session_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['provider_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_shm_hitalama_agent_session_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['provider_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_hitalama_agent_session_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_agent_session_17 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['Provider'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_select__value_shm_hitalama_agent_session_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['model_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_shm_hitalama_agent_session_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['model_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_shm_hitalama_agent_session_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['model_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_hitalama_agent_session_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_agent_session_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['Model'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_hitalama_agent_session_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['custom_provider_id'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_agent_session_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_agent_session_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['Custom_provider_id'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_hitalama_agent_session_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['custom_provider_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_agent_session_27 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_agent_session_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['Custom_provider_name'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_hitalama_agent_session_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['custom_provider_base_url'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_agent_session_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_agent_session_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['Custom_provider_base_url'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_password__value_shm_hitalama_agent_session_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['custom_provider_api_key'] >
		,
		ReturnType< $mol_password['value'] >
	>
	type $mol_labeler__title_shm_hitalama_agent_session_33 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_agent_session_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['Custom_provider_api_key'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_hitalama_agent_session_35 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['custom_provider_model_id'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_agent_session_36 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_agent_session_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['Custom_provider_model_id'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_hitalama_agent_session_38 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['custom_provider_model_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_agent_session_39 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_agent_session_40 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['Custom_provider_model_name'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_button_major__sub_shm_hitalama_agent_session_41 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['custom_provider_add_content'] >
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_hitalama_agent_session_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['custom_provider_add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_list__rows_shm_hitalama_agent_session_43 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_expander__attr_shm_hitalama_agent_session_44 = $mol_type_enforce<
		({ 
			'hidden': ReturnType< $shm_hitalama_agent_session['backend_dsh'] >,
		})  & ReturnType< $mol_expander['attr'] >
		,
		ReturnType< $mol_expander['attr'] >
	>
	type $mol_expander__title_shm_hitalama_agent_session_45 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__expanded_shm_hitalama_agent_session_46 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['custom_provider_expanded'] >
		,
		ReturnType< $mol_expander['expanded'] >
	>
	type $mol_expander__content_shm_hitalama_agent_session_47 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $mol_check_box__attr_shm_hitalama_agent_session_48 = $mol_type_enforce<
		({ 
			'hidden': ReturnType< $shm_hitalama_agent_session['backend_dsh'] >,
		})  & ReturnType< $mol_check_box['attr'] >
		,
		ReturnType< $mol_check_box['attr'] >
	>
	type $mol_check_box__title_shm_hitalama_agent_session_49 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_agent_session_50 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['no_reply'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_button_minor__sub_shm_hitalama_agent_session_51 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_agent_session_52 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['export_session'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_53 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__hint_shm_hitalama_agent_session_54 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_agent_session_55 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_agent_session_56 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_view__event_shm_hitalama_agent_session_57 = $mol_type_enforce<
		({ 
			scroll( next?: ReturnType< $shm_hitalama_agent_session['messages_scroll'] > ): ReturnType< $shm_hitalama_agent_session['messages_scroll'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_58 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['message_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__sub_shm_hitalama_agent_session_59 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_hitalama_agent_session_60 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['messages_to_bottom'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_61 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_hitalama_agent_session_62 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['send_error'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__attr_shm_hitalama_agent_session_63 = $mol_type_enforce<
		({ 
			'hidden': ReturnType< $shm_hitalama_agent_session['send_error_hidden'] >,
		})  & ReturnType< $mol_paragraph['attr'] >
		,
		ReturnType< $mol_paragraph['attr'] >
	>
	type $mol_textarea__value_shm_hitalama_agent_session_64 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['prompt'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_textarea__submit_shm_hitalama_agent_session_65 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['send_button_click'] >
		,
		ReturnType< $mol_textarea['submit'] >
	>
	type $mol_button_minor__sub_shm_hitalama_agent_session_66 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['send_button_content'] >
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_agent_session_67 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['send_button_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_agent_session_68 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['send_button_click'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_page__title_shm_hitalama_agent_session_69 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['chat_title'] >
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__sub_shm_hitalama_agent_session_70 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['sub'] >
	>
	type $mol_page__tools_shm_hitalama_agent_session_71 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_hitalama_agent_session_72 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_page__foot_shm_hitalama_agent_session_73 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['foot'] >
	>
	type $mol_button_minor__sub_shm_hitalama_agent_session_74 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_agent_session_75 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_paragraph__title_shm_hitalama_agent_session_76 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_status'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__event_shm_hitalama_agent_session_77 = $mol_type_enforce<
		({ 
			scroll( next?: ReturnType< $shm_hitalama_agent_session['thinking_scroll'] > ): ReturnType< $shm_hitalama_agent_session['thinking_scroll'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_78 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_step_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_major__sub_shm_hitalama_agent_session_79 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_major['sub'] >
	>
	type $mol_button_major__click_shm_hitalama_agent_session_80 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_to_bottom'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_81 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_page__title_shm_hitalama_agent_session_82 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__tools_shm_hitalama_agent_session_83 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['tools'] >
	>
	type $mol_page__body_shm_hitalama_agent_session_84 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_paragraph__title_shm_hitalama_agent_session_85 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['message_role'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_link__arg_shm_hitalama_agent_session_86 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['message_thinking_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_hitalama_agent_session_87 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_paragraph__title_shm_hitalama_agent_session_88 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['message_time'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_89 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_text__text_shm_hitalama_agent_session_90 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['message_system_prompt'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $mol_expander__title_shm_hitalama_agent_session_91 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__expanded_shm_hitalama_agent_session_92 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['message_system_prompt_expanded'] >
		,
		ReturnType< $mol_expander['expanded'] >
	>
	type $mol_expander__content_shm_hitalama_agent_session_93 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	type $shm_hitalama_text__text_shm_hitalama_agent_session_94 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['message_text'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_95 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_96 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['message_question_option_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_hitalama_agent_session_97 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_part_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_98 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_part_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_card__theme_shm_hitalama_agent_session_99 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['message_theme'] >
		,
		ReturnType< $mol_card['theme'] >
	>
	type $mol_card__attr_shm_hitalama_agent_session_100 = $mol_type_enforce<
		({ 
			'role': ReturnType< $shm_hitalama_agent_session['message_role_key'] >,
		})  & ReturnType< $mol_card['attr'] >
		,
		ReturnType< $mol_card['attr'] >
	>
	type $mol_card__sub_shm_hitalama_agent_session_101 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['sub'] >
	>
	type $mol_card__sub_shm_hitalama_agent_session_102 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['sub'] >
	>
	type $shm_hitalama_text__text_shm_hitalama_agent_session_103 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_part_text_line_by_key'] >
		,
		ReturnType< $shm_hitalama_text['text'] >
	>
	type $mol_view__sub_shm_hitalama_agent_session_104 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_plain_row_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_agent_tool_card__name_shm_hitalama_agent_session_105 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_tool_name'] >
		,
		ReturnType< $shm_hitalama_agent_tool_card['name'] >
	>
	type $shm_hitalama_agent_tool_card__status_shm_hitalama_agent_session_106 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_tool_status'] >
		,
		ReturnType< $shm_hitalama_agent_tool_card['status'] >
	>
	type $shm_hitalama_agent_tool_card__input_shm_hitalama_agent_session_107 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_tool_input'] >
		,
		ReturnType< $shm_hitalama_agent_tool_card['input'] >
	>
	type $shm_hitalama_agent_tool_card__options_shm_hitalama_agent_session_108 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_tool_option_rows'] >
		,
		ReturnType< $shm_hitalama_agent_tool_card['options'] >
	>
	type $shm_hitalama_agent_tool_card__content_shm_hitalama_agent_session_109 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_tool_content'] >
		,
		ReturnType< $shm_hitalama_agent_tool_card['content'] >
	>
	type $shm_hitalama_agent_tool_card__error_shm_hitalama_agent_session_110 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['thinking_tool_error'] >
		,
		ReturnType< $shm_hitalama_agent_tool_card['error'] >
	>
	type $mol_button_minor__title_shm_hitalama_agent_session_111 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['question_option_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_agent_session_112 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['question_option_reply'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_agent_session_113 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['message_question_option_title'] >
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_agent_session_114 = $mol_type_enforce<
		ReturnType< $shm_hitalama_agent_session['message_question_option_reply'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	export class $shm_hitalama_agent_session extends $mol_book2 {
		chat_title( ): string
		Chat_page_head( ): ReturnType< ReturnType< $shm_hitalama_agent_session['Chat_page'] >['Head'] >
		Chat_page_body( ): ReturnType< ReturnType< $shm_hitalama_agent_session['Chat_page'] >['Body'] >
		Chat_page_foot( ): ReturnType< ReturnType< $shm_hitalama_agent_session['Chat_page'] >['Foot'] >
		chat_page_head( ): readonly(any)[]
		chat_backend_label( ): string
		Chat_backend( ): $mol_paragraph
		agent_config( next?: string ): string
		agent_config_dictionary( ): Record<string, any>
		Agent_config( ): $mol_select
		chat_model_hint( ): string
		chat_model_label( ): string
		Chat_model( ): $mol_view
		context_hint( ): string
		context_usage_level( ): string
		context_label( ): string
		Chat_tokens( ): $mol_view
		Chat_settings_icon( ): $mol_icon_cog_outline
		view_mode( next?: string ): string
		View_mode( ): $mol_switch
		View_mode_label( ): $mol_labeler
		provider_id( next?: string ): string
		provider_options( ): readonly(any)[]
		provider_dict( ): Record<string, any>
		Provider( ): $mol_select
		Provider_label( ): $mol_labeler
		model_id( next?: string ): string
		model_options( ): readonly(any)[]
		model_dict( ): Record<string, any>
		Model( ): $mol_select
		Model_label( ): $mol_labeler
		backend_dsh( ): boolean
		custom_provider_expanded( next?: boolean ): boolean
		custom_provider_id( next?: string ): string
		Custom_provider_id( ): $mol_string
		Custom_provider_id_label( ): $mol_labeler
		custom_provider_name( next?: string ): string
		Custom_provider_name( ): $mol_string
		Custom_provider_name_label( ): $mol_labeler
		custom_provider_base_url( next?: string ): string
		Custom_provider_base_url( ): $mol_string
		Custom_provider_base_url_label( ): $mol_labeler
		custom_provider_api_key( next?: string ): string
		Custom_provider_api_key( ): $mol_password
		Custom_provider_api_key_label( ): $mol_labeler
		custom_provider_model_id( next?: string ): string
		Custom_provider_model_id( ): $mol_string
		Custom_provider_model_id_label( ): $mol_labeler
		custom_provider_model_name( next?: string ): string
		Custom_provider_model_name( ): $mol_string
		Custom_provider_model_name_label( ): $mol_labeler
		custom_provider_add_content( ): readonly(any)[]
		custom_provider_add( next?: any ): any
		Custom_provider_add( ): $mol_button_major
		Custom_provider_content( ): $mol_list
		Custom_provider( ): $mol_expander
		no_reply( next?: boolean ): boolean
		No_reply( ): $mol_check_box
		Export_session_icon( ): $mol_icon_download
		export_session( next?: any ): any
		Export_session( ): $mol_button_minor
		Chat_settings_content( ): $mol_view
		Chat_settings( ): $mol_pick
		messages_scroll( next?: any ): any
		message_rows( ): readonly(any)[]
		Messages( ): $mol_view
		Messages_new_icon( ): $mol_icon_arrow_down
		messages_to_bottom( next?: any ): any
		Messages_new( ): $mol_button_major
		Messages_box( ): $mol_view
		send_error( next?: string ): string
		send_error_hidden( ): boolean
		Send_error( ): $mol_paragraph
		prompt( next?: string ): string
		send_button_click( next?: any ): any
		Prompt( ): $mol_textarea
		send_button_content( ): readonly(any)[]
		send_button_enabled( ): boolean
		Send( ): $mol_button_minor
		Chat_page( ): $mol_page
		Thinking_close_icon( ): $mol_icon_close
		thinking_close( next?: any ): any
		Thinking_close( ): $mol_button_minor
		thinking_status( ): string
		Thinking_status( ): $mol_paragraph
		thinking_scroll( next?: any ): any
		thinking_step_rows( ): readonly(any)[]
		Thinking_parts( ): $mol_view
		Thinking_down_icon( ): $mol_icon_arrow_down
		thinking_to_bottom( next?: any ): any
		Thinking_down( ): $mol_button_major
		Thinking_box( ): $mol_view
		Thinking_page( ): $mol_page
		session_pages( ): readonly(any)[]
		message_theme( id: any): string
		message_role_key( id: any): string
		message_role( id: any): string
		Message_role( id: any): $mol_paragraph
		message_thinking_arg( id: any): Record<string, any>
		Message_thinking_icon( id: any): $mol_icon_eye
		message_thinking_title( id: any): string
		Message_thinking( id: any): $mol_link
		message_time( id: any): string
		Message_time( id: any): $mol_paragraph
		Message_head( id: any): $mol_view
		message_system_prompt_expanded( id: any, next?: boolean ): boolean
		message_system_prompt( id: any): string
		Message_system_prompt_text( id: any): $shm_hitalama_text
		Message_system_prompt( id: any): $mol_expander
		message_text( id: any): string
		Message_text( id: any): $shm_hitalama_text
		Message_text_box( id: any): $mol_view
		message_question_option_rows( id: any): readonly(any)[]
		Message_question_options( id: any): $mol_view
		thinking_part_title( id: any): string
		Thinking_part_title( id: any): $mol_paragraph
		thinking_part_rows( id: any): readonly(any)[]
		Thinking_part_items( id: any): $mol_view
		thinking_part_text_line_by_key( id: any): string
		thinking_plain_row_content( id: any): readonly(any)[]
		thinking_tool_name( id: any): string
		thinking_tool_status( id: any): string
		thinking_tool_input( id: any): string
		thinking_tool_option_rows( id: any): readonly(any)[]
		thinking_tool_content( id: any): string
		thinking_tool_error( id: any): string
		question_option_title( id: any): string
		question_option_reply( id: any, next?: any ): any
		message_question_option_title( id: any): string
		message_question_option_reply( id: any, next?: any ): any
		server_url( ): string
		session_id( next?: string ): string
		placeholders( ): readonly(any)[]
		Send_icon( ): $mol_icon_send
		Stop_icon( ): $mol_icon_stop
		pages( ): ReturnType< $shm_hitalama_agent_session['session_pages'] >
		Message_row( id: any): $mol_card
		Thinking_part_row( id: any): $mol_card
		Thinking_text_row( id: any): $shm_hitalama_text
		Thinking_plain_row( id: any): $mol_view
		Thinking_tool_row( id: any): $shm_hitalama_agent_tool_card
		Question_option( id: any): $mol_button_minor
		Message_question_option( id: any): $mol_button_minor
	}
	
}

//# sourceMappingURL=session.view.tree.d.ts.map